import DynaLoader from './DynaLoader';

interface TokenCountComponentProps {
  tokenCount: string | null;
  /** The immutable hard cap, read from the contract's TOKEN_LIMIT(). */
  tokenLimit: string | null;
  loading: boolean;
}

const TokenCountComponent = ({ tokenCount, tokenLimit, loading }: TokenCountComponentProps) => {
  if (loading) {
    return (
      <div>
        <DynaLoader variant="inline" label="Loading token count" />
      </div>
    );
  }

  return (
    <div>
      Tokens minted: {tokenCount ?? "?"} / {tokenLimit ?? "?"}
    </div>
  );
}

export default TokenCountComponent;
